import { Link, useLocation, useNavigate } from 'react-router-dom';

import { GROUP_LABEL, GROUP_ORDER, NAV, matchNav } from './nav-config';
import { clearAccessToken } from '../lib/auth';

/**
 * 設計系統側邊欄（對應 docs/cms-screens 之 Component/Sidebar）。
 *
 * 深色 #0B2233 底；依 group 分區渲染；active 由 matchNav 以最長前綴判定，
 * 故子路由（/products/new）仍會點亮其父項（商品管理）。
 */
export function Sidebar(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const active = matchNav(location.pathname);

  function onLogout(): void {
    clearAccessToken();
    navigate('/login', { replace: true });
  }

  return (
    <aside className="app-sidebar">
      <div className="app-sidebar__brand">
        <div className="app-sidebar__logo">⚓</div>
        <div>
          <div className="app-sidebar__brand-name">Boat Ticket CMS</div>
          <div className="app-sidebar__brand-sub">安平遊艇票務管理</div>
        </div>
      </div>

      {GROUP_ORDER.map((group) => {
        const items = NAV.filter((n) => n.group === group);
        if (items.length === 0) return null;
        return (
          <div key={group}>
            <div className="nav-group-label">{GROUP_LABEL[group]}</div>
            {items.map((it) => (
              <Link
                key={it.to}
                to={it.to}
                className={`nav-item${active?.to === it.to ? ' active' : ''}`}
              >
                <span className="nav-item__icon">{it.icon}</span>
                <span>{it.label}</span>
              </Link>
            ))}
          </div>
        );
      })}

      <div className="app-sidebar__spacer" />
      <button type="button" className="nav-item" onClick={onLogout}>
        <span className="nav-item__icon">🚪</span>
        <span>登出</span>
      </button>
    </aside>
  );
}
